import * as React from 'react';
import { Button, Icon, Table, Upload, message } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import { EventSubscription } from 'fbemitter';

import RoleRequirementDispatcher from '../../dispatchers/RoleRequirementDispatcher';
import RoleRequirementStore from '../../stores/RoleRequirementStore';
import { removeListener } from '../../utils';

interface RoleRequiementTabData {
  roleRequirements: RoleRequirement[];
}

export class RoleRequirementsTab extends React.Component<
  {},
  RoleRequiementTabData
> {
  private roleReqListener: EventSubscription | null = null;

  constructor(props: {}) {
    super(props);

    this.state = {
      roleRequirements: RoleRequirementStore.getRoleRequirements(),
    };
  }

  render() {
    const uniqueTerms: string[] = [];
    const uniqueRoles: string[] = [];
    this.state.roleRequirements.forEach((r: RoleRequirement) => {
      if (uniqueTerms.indexOf(r.term) === -1) {
        uniqueTerms.push(r.term);
      }
      if (uniqueRoles.indexOf(r.role) === -1) {
        uniqueRoles.push(r.role);
      }
    });

    return (
      <span>
        <div className="center buffer">
          <Upload
            accept=".csv"
            action="/api/upload_roles_csv"
            onChange={this.handleUploadChange}
            showUploadList={false}
            withCredentials={true}
          >
            <Button>
              <Icon type="upload" /> Upload and Overwrite Role Requirements
            </Button>
          </Upload>
        </div>
        <Table
          dataSource={this.state.roleRequirements}
          rowKey={(r: RoleRequirement) => r.role + ':' + r.term}
          size="small"
          pagination={false}
          columns={[
            {
              title: 'Role',
              dataIndex: 'role',
              key: 'role',
              sorter: (a: RoleRequirement, b: RoleRequirement) => {
                return a.role.localeCompare(b.role);
              },
              filters: uniqueRoles.map((r: string) => {
                return {
                  text: r,
                  value: r,
                };
              }),
              onFilter: (v: string, r: RoleRequirement) => r.role === v,
            },
            {
              title: 'Term',
              dataIndex: 'term',
              key: 'term',
              sorter: (a: RoleRequirement, b: RoleRequirement) => {
                return a.term.localeCompare(b.term);
              },
              filters: uniqueTerms.map((t: string) => {
                return {
                  text: t,
                  value: t,
                };
              }),
              onFilter: (v: string, r: RoleRequirement) => r.term === v,
            },
            {
              title: 'Days',
              dataIndex: 'days',
              key: 'days',
            },
          ]}
        />
      </span>
    );
  }

  componentDidMount() {
    this.roleReqListener = RoleRequirementStore.addListener(() => {
      this.setState({
        roleRequirements: RoleRequirementStore.getRoleRequirements(),
      });
    });
  }

  componentWillUnmount() {
    removeListener(this.roleReqListener);
  }

  private handleUploadChange(params: UploadChangeParam) {
    if (params.file.status === 'done') {
      message.success('CSV file uploaded successfully;');
      RoleRequirementDispatcher.handleUpdateRoleRequirements(
        params.file.response
      );
    } else if (params.file.status === 'error') {
      message.error('CSV file upload failed.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminTabs/RoleRequirementsTab.tsx